import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from './../images/circle-info-regular-full.svg'

function KeywordFeature ({ featureKeywordLocal, setFeatureKeywordLocal }) {
  const handleKeywordChange = e => {
    const { id, value } = e.target
    setFeatureKeywordLocal(prev => ({
      ...prev,
      [id]: value
    }))
  }

  return (
    <section className={styles.keywordFeatureSection}>
      <h1 className={styles.keywordFeatureTitle}>Keyword search</h1>
      <div className={styles.sectionTitleWithIcon}> </div>

      <div className={styles.keywordFeatureContainer}>
        {/* Feature key */}
        <div className={styles.keywordFeatureColumn}>
          <div className={styles.labelWithIcon}>
            <label className={styles.FeatureKeywordLabel} htmlFor='key'>
              Feature key
            </label>
            <Tooltip
              title='Filter by feature key'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 400,
                      fontSize: '13px',
                      padding: '10px 14px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Feature key help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>
          <input
            placeholder='Key'
            className={styles.FeatureKeywordInput}
            type='text'
            autoComplete='off'
            id='key'
            value={featureKeywordLocal.key}
            onChange={handleKeywordChange}
          />
        </div>

        {/* Feature value */}
        <div className={styles.keywordFeatureColumn}>
          <div className={styles.labelWithIcon}>
            <label className={styles.FeatureKeywordLabel} htmlFor='value'>
              Feature value
            </label>
            <Tooltip
              title='Filter by feature value.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Feature value help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>
          <input
            placeholder='Value'
            className={styles.FeatureKeywordInput}
            type='text'
            autoComplete='off'
            id='value'
            value={featureKeywordLocal.value}
            onChange={handleKeywordChange}
          />
        </div>
      </div>
    </section>
  )
}

export default KeywordFeature
